   module.controller('helpTourCntrl', function(esb, xmppAuth, theme, services, $sce, $scope, $cookieStore, $cookies, $http,  $localStorage, $mdDialog, $window, dataToPass, showFileChoose) {

    $scope.myInterval = 0;
    $scope.noWrapSlides = false;
    $scope.active = 0;
    var slides = $scope.slides = [];
    $scope.textColor = "#000000";
    $scope.backgroundColor = "#FFFFFF";
    var theme = theme.getTheme();
    if(theme && theme.help_background_color)
      $scope.backgroundColor = theme.help_background_color

    if(theme && theme.help_text_color)
      $scope.textColor = theme.help_text_color


    $scope.closeDialog = function(){
      $mdDialog.cancel();
    };

    if(dataToPass){

      var help = dataToPass.metadata.help;     
      
    }
    else
        if($localStorage.msg) {
        var messages =  $localStorage.msg;
        var lastMessage = messages[messages.length-1];
        var help = lastMessage.metadata.help;     
      }
    
    $scope.addSlide = function(message) {       
      slides.push(message);
    }; 

    for (var i = 0; i < help.messages.length; i++) {
      var message = help.messages[i];
      message.id = i;
      if (message.image){
          message.image = (message.image.includes("http")?message.image:esb+"/security"+message.image);
      }
      if (message.messages){
          for (var j = 0; j < message.messages.length; j++) {
              let messageItem = message.messages[j];
              messageItem.id = j;
              if (messageItem.image){
                  messageItem.image = (messageItem.image.includes("http") ? messageItem.image:esb+"/security"+messageItem.image)
              }
          }
      }
      $scope.addSlide(message);
    }
    
    $scope.renderHtml = function (htmlCode) {
      return $sce.trustAsHtml(htmlCode);
    };
    
    $scope.showNext = true;
    if($scope.slides.length == 1) {
      $scope.showNext = false;
    }     
    $scope.showPrev = false;
    $scope.nextSlide = function() {   
      $scope.goNext();
    }

    $scope.prevSlide = function() {      
      $scope.goPrev();
    }
    $scope.lastSlide = function() {
      if(showFileChoose == 100)
        $("#file").trigger('click');             
      $mdDialog.hide();
    }
    
    $scope.$watch('active', function(newIndex, oldIndex) {
      if (Number.isFinite(newIndex) && newIndex!==oldIndex) {        
         $scope.showNext = newIndex != $scope.slides.length - 1; 
         $scope.showPrev = newIndex != 0; 
      }
  });
    
    });
    